import { createClient } from "@supabase/supabase-js";

import { config } from "../../config";
import type { Database } from "../../types/database.types";

const supabaseUrl = config.supabaseUrl;
const supabaseAnonKey = config.supabaseAnonKey;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase environment variables");
}

// createClientSupabase.ts

export function createClientSupabase<TDatabase = Database>() {
  /**
   * Msw cannot intercept the default cross-fetch
   * @link https://github.com/supabase/supabase/issues/27656
   */
  if (process.env.NODE_ENV === "test") {
    return createClient<TDatabase>(
      supabaseUrl!,
      supabaseAnonKey!,
      { auth: {
        persistSession: true,
        autoRefreshToken: true
      },
      global: {
        fetch: (...args) => fetch(...args)
      } }
    );
  }

  return createClient<TDatabase>(
    supabaseUrl!,
    supabaseAnonKey!,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true
      }
    }
  );
}

export const supabase = createClientSupabase<Database>();
